'use client';

import type { GfProductColor } from '@/types';
// import { formatCurrency } from '@/utils/formatters';
import OptionTitle from '../OptionTitle/OptionTitle';
import styles from './GfColorList.module.scss';

function GfColorList({
  colors,
  onColorSelect,
  // biome-ignore lint/correctness/noUnusedVariables: カラーごとの価格差がなくなるため一旦コメントアウト
  productBasePrice,
  selectedColorId,
  showColorName = true,
  iconSize = 'default',
  title = '色を選択',
}: {
  colors: GfProductColor[];
  onColorSelect?: (colorId: number) => void;
  productBasePrice?: number;
  selectedColorId: number;
  showColorName?: boolean;
  iconSize?: 'small' | 'default';
  title?: string;
}) {
  const handleColorClick = (colorId: number) => {
    if (onColorSelect) {
      onColorSelect(colorId);
    }
  };

  return (
    <div className={styles.productColorOptionContainer}>
      <OptionTitle title={title} />
      {selectedColorId === 0 && <p className={styles.productColorValidationErrorMessage}>カラーが未選択です</p>}
      <div className={`${styles.productColorsContainer} ${styles[`${iconSize}Container`]}`}>
        {colors.map((color) => {
          const isSelected = selectedColorId === color.id;
          return (
            <div
              className={`${styles.productColorItemContainer} ${styles[`${iconSize}ItemContainer`]}`}
              key={color.id}
              onClick={() => handleColorClick(color.id)}
              data-testid={`product-color-option-${color.id}`}
            >
              <div
                className={`
                  ${styles.productColorItem}
                  ${styles[`${iconSize}ColorItem`]}
                  ${isSelected ? styles.activeCircle : ''}
                `}
                style={{ backgroundColor: color.colorCode }}
              />
              {showColorName && <p className={styles.productColorName}>{color.name}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GfColorList;
